import React, {
    useEffect,
    useState,
} from "react";

import ReactDOM from "react-dom";

import {
    FiAlertTriangle,
    FiX,
} from "react-icons/fi";

import "./EmployeeCommon.css";


const EmployeeConfirmModal = ({
    open,

    title =
        "Confirm Action",

    description =
        "",

    confirmLabel =
        "Confirm",

    cancelLabel =
        "Cancel",

    requireReason =
        false,

    reasonLabel =
        "Reason",

    reasonPlaceholder =
        "Enter reason",

    loading =
        false,

    danger =
        false,

    onClose,

    onConfirm,
}) => {

    const [
        reason,
        setReason,
    ] =
        useState("");


    const [
        error,
        setError,
    ] =
        useState("");


    useEffect(
        () => {

            if (
                open
            ) {

                setReason("");
                setError("");

            }

        },
        [
            open,
        ]
    );


    if (
        !open
    ) {
        return null;
    }


    const handleConfirm =
        async () => {

            if (
                requireReason &&
                !reason.trim()
            ) {

                setError(
                    "Reason is required."
                );

                return;

            }


            await onConfirm?.(
                reason.trim()
            );

        };


    return ReactDOM
        .createPortal(

            <div className="employee-confirm-root">

                <button
                    type="button"
                    className="employee-confirm-backdrop"
                    onClick={
                        loading
                            ? undefined
                            : onClose
                    }
                    aria-label="Close"
                />


                <div className="employee-confirm-dialog">

                    <button
                        type="button"
                        className="employee-confirm-close"
                        onClick={
                            onClose
                        }
                        disabled={
                            loading
                        }
                    >

                        <FiX />

                    </button>


                    <div
                        className={
                            danger
                                ? "employee-confirm-icon employee-confirm-icon--danger"
                                : "employee-confirm-icon"
                        }
                    >

                        <FiAlertTriangle />

                    </div>


                    <h3>
                        {title}
                    </h3>


                    {
                        description
                            ? (
                                <p>
                                    {description}
                                </p>
                            )
                            : null
                    }


                    {
                        requireReason
                            ? (
                                <div className="employee-confirm-reason">

                                    <label>
                                        {reasonLabel}
                                    </label>


                                    <textarea
                                        value={
                                            reason
                                        }
                                        onChange={
                                            (
                                                event
                                            ) => {

                                                setReason(
                                                    event
                                                        .target
                                                        .value
                                                );

                                                setError("");

                                            }
                                        }
                                        placeholder={
                                            reasonPlaceholder
                                        }
                                        disabled={
                                            loading
                                        }
                                    />


                                    {
                                        error
                                            ? (
                                                <small className="employee-common-error">
                                                    {error}
                                                </small>
                                            )
                                            : null
                                    }

                                </div>
                            )
                            : null
                    }


                    <div className="employee-confirm-actions">

                        <button
                            type="button"
                            className="employee-common-secondary-btn"
                            onClick={
                                onClose
                            }
                            disabled={
                                loading
                            }
                        >

                            {cancelLabel}

                        </button>


                        <button
                            type="button"
                            className={
                                danger
                                    ? "employee-common-danger-btn"
                                    : "employee-common-primary-btn"
                            }
                            onClick={
                                handleConfirm
                            }
                            disabled={
                                loading
                            }
                        >

                            {
                                loading
                                    ? "Please wait..."
                                    : confirmLabel
                            }

                        </button>

                    </div>

                </div>

            </div>,

            document.body

        );

};


export default EmployeeConfirmModal;